import React, {Component} from 'react';
import {Button} from 'material-ui';
import ArrowUp from 'material-ui-icons/ArrowUpward';

class ScrollToTop extends Component {
    constructor() {
        super();

        this.state = {
            intervalId: 0,
            position: 0
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () =>  {
        this.setState({
            position: window.pageYOffset
        });
    };
      
    scrollStep = () => {
        let scrollStepInPx = "30";

        if (window.pageYOffset === 0) {
            clearInterval(this.state.intervalId);
        }
        window.scroll(0, window.pageYOffset - scrollStepInPx);
    }
    
    scrollToTop = () => {
        let delayInMs= "10";
        let intervalId = setInterval(this.scrollStep, delayInMs);

        this.setState({
            intervalId: intervalId
        });
    }

    
    render () {
        return (
            this.state.position > 300 &&
            <Button
                color="primary"
                className="scrollButton"
                title='Back to top'
                variant="fab"
                onClick={() => this.scrollToTop()}
            >
                <ArrowUp />
            </Button>
        )
    }
}

export default ScrollToTop;


// WEBPACK FOOTER //
// ./src/components/scroll-top/ScrollToTop.jsx